import { render, staticRenderFns } from "./DialogDelete.vue?vue&type=template&id=56ded43c&scoped=true"
import script from "./DialogDelete.vue?vue&type=script&lang=js"
export * from "./DialogDelete.vue?vue&type=script&lang=js"
import style0 from "./DialogDelete.vue?vue&type=style&index=0&id=56ded43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ded43c",
  null
  
)

export default component.exports